import { createContext, useContext } from 'react';

/** @type {React.Context<DrawerContextValue|null>} */
export const DrawerContext = createContext(null);

/**
 * Returns the DrawerContext value; must be used inside NavigationDrawer.
 *
 * @returns {DrawerContextValue}
 */
export const useDrawer = () => {
	const context = useContext(DrawerContext);
	if (context === null) {
		throw new Error(
			'useDrawer must be used within a DrawerContext.Provider (NavigationDrawer)'
		);
	}
	return context;
};
